/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScreenerSetting
 */
export interface ScreenerSetting {
    /**
     * 
     */
    setting_name: string;
    /**
     * 
     */
    value: string;
}

/**
 * Check if a given object implements the ScreenerSetting interface.
 */
export function instanceOfScreenerSetting(value: object): value is ScreenerSetting {
    if (!('setting_name' in value) || value['setting_name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function ScreenerSettingFromJSON(json: any): ScreenerSetting {
    return ScreenerSettingFromJSONTyped(json, false);
}

export function ScreenerSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerSetting {
    if (json == null) {
        return json;
    }
    return {
        
        'setting_name': json['setting_name'],
        'value': json['value'],
    };
}

export function ScreenerSettingToJSON(json: any): ScreenerSetting {
    return ScreenerSettingToJSONTyped(json, false);
}

export function ScreenerSettingToJSONTyped(value?: ScreenerSetting | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'setting_name': value['setting_name'],
        'value': value['value'],
    };
}

